import React, { Component } from 'react';
import { div } from 'react-router-dom';
import parse from 'html-react-parser';

class CategoryV1 extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isMobile: window.innerWidth <= 768,
		};
	}

	handleResize = () => {
		this.setState({ isMobile: window.innerWidth <= 768 });
	};

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'
		const { isMobile } = this.state;

		const iconStyle = {
			width: isMobile ? '60px' : '100px',
			height: isMobile ? '60px' : '100px',
			borderRadius: '50%',
			marginBottom: '20px',
			backgroundColor: '#f1f9cf',
			padding: isMobile ? '10px' : '20px',
		};

    return <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-90 go-top">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-12">
			        <div className="section-title-area ltn__section-title-2--- text-center">
			          <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Key Features</h6>
			          <h1 className="section-title">What You Get</h1>
			        </div>
			      </div>
			    </div>
				
			    <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center">
				<div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            {/* <span className="category-icon" > */}
							<img src={publicUrl+"assets/img/icons/icon-img/Location-Acecess.svg"} alt="#" style={iconStyle}  />
						{/* </span> */}
			            <span className="category-title">Location Access</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			    </div>
			      {/* <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            <span className="category-icon"><i className="flaticon-car" /></span>
			            <span className="category-title"></span>
			          </div>
			        </div>
			      </div> */}
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            <span className="category-icon"><i className="flaticon-swimming" /></span>
			            <span className="category-title">24/7 Water Access</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            <span className="category-icon"><i className="flaticon-secure-shield" /></span>
			            <span className="category-title">Gated Security</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            <span className="category-icon"><i className="flaticon-stethoscope" /></span>
			            <span className="category-title">Nearby Hospitals</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            <span className="category-icon"><i className="flaticon-book" /></span>
			            <span className="category-title">Plot Assistance Office</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			      </div>
				  <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            {/* <span className="category-icon" > */}
							<img src={publicUrl+"assets/img/icons/icon-img/under-Goround-Cabling.svg"} alt="#" style={iconStyle}  />
						{/* </span> */}
			            <span className="category-title">Underground Cabling</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			    </div>
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            {/* <span className="category-icon"><i className="flaticon-bed-1" /></span> */}
						<img src={publicUrl+"assets/img/icons/icon-img/appreciation.svg"} alt="#" style={iconStyle}  />
			            <span className="category-title">High Appreciation Potential</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-4 col-sm-6 col-6">
			        <div className="ltn__category-item ltn__category-item-5 text-center">
			          <div>
			            {/* <span className="category-icon" > */}
							<img src={publicUrl+"assets/img/icons/icon-img/connect-roads.svg"} alt="#" style={iconStyle}  />
						{/* </span> */}
			            <span className="category-title">Easy Connectivity to Main Roads</span>
			            {/* <span className="category-btn"><i className="flaticon-right-arrow" /></span> */}
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default CategoryV1